import { render, staticRenderFns } from "./SanityEnglish.vue?vue&type=template&id=a9730c68&"
import script from "./SanityEnglish.vue?vue&type=script&lang=js&"
export * from "./SanityEnglish.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports